
import { Component, Emit, Inject, Prop, Provide, Vue, Watch } from 'vue-property-decorator';
import { v4 as uuid } from 'uuid';
/**
 * チェックボックスコンポーネント。
 *
 * Controlled Componentで、valueに基づき状態を決定します。
 *
 * changeがemitされたら利用者側でvalueに渡す状態を更新してください。
 */
@Component({})
export default class CheckBox extends Vue {
  @Prop({ default: () => uuid() })
  id!: string;

  @Prop({ default: 'text' }) variant?: 'text' | 'fill';

  @Prop({ default: false })
  checked?: boolean;
  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: '' })
  value!: string;

  @Inject({
    default: undefined,
  })
  check?: (value: string) => void;

  get wrapperClasses() {
    return {
      'checkbox-wrapper-base': true,
      'checkbox-wrapper-text': this.variant === 'text',
      'checkbox-wrapper-text-checked': this.variant === 'text' && this.checked,
      'checkbox-wrapper-fill': this.variant === 'fill',
      'checkbox-wrapper-fill-checked': this.variant === 'fill' && this.checked,
      'checkbox-text-disabled': this.disabled && !this.checked,
      'checkbox-text-disabled-checked': this.disabled && this.checked,
    };
  }

  onCheck(_: Event) {
    this.check && this.check(this.value);
    this.onChange();
  }

  @Emit('onChange')
  onChange() {}
}
